import type { EntityManager } from "yuka";

export const yukaManagerRef: { current: EntityManager | null } = {
  current: null,
};
